import axios from "axios";

import URL from "config/envUrls";

export const loginUser = ({ username, password }) => {
  const apiEndPoint = "baseModule/userManagement/login";
  return axios.post(`${URL.API.baseURL}${apiEndPoint}`, {
    username,
    password
  });
};

export const getStartDay = sessionKey => {
  const apiEndPoint = "systemAdmin/systemUserManagement/getStartDayOfWeek";
  return axios.get(`${URL.API.baseURL}${apiEndPoint}`, {
    headers: {
      sessionKey
    }
  });
};

export const requestPasswordReset = ({ targetResetUrl, usernameEmail }) => {
  const apiEndPoint = "baseModule/userManagement/requestResetPassword";
  return axios.post(`${URL.API.baseURL}${apiEndPoint}?usernameOrEmail=${usernameEmail}&targetResetUrl=${targetResetUrl}`);
};

export const completePasswordReset = ({ newPassword, passwordResetKey }) => {
  const apiEndPoint = "baseModule/userManagement/requestCompleteResetPassword";
  return axios.post(`${URL.API.baseURL}${apiEndPoint}`, {
    newPassword,
    passwordResetKey
  });
};